import { buttonVariants } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Link, RouteComponentProps } from "wouter";

type ComingSoonProps = {
  title?: string;
  description?: string;
  imageSrc?: string;
  imageAlt?: string;
  homeHref?: string;
};

type ComingSoonRouteProps = RouteComponentProps & ComingSoonProps;

export function ComingSoonView({
  title,
  description,
  imageSrc = "",
  imageAlt = "",
  homeHref = "/",
}: ComingSoonRouteProps) {
  const { t } = useTranslation("common");

  return (
    <div className="relative flex min-h-screen w-full items-center justify-center bg-neutral-900">
      <div className="z-50 mx-auto max-w-screen-sm px-4 text-center">
        {imageSrc && (
          <img
            src={imageSrc}
            alt={imageAlt}
            aria-hidden={imageAlt ? undefined : true}
            loading="lazy"
            decoding="async"
            className="mx-auto mb-6 h-48 w-auto select-none"
          />
        )}
        <h1 className="mb-6 text-5xl font-extrabold tracking-tight text-white lg:text-7xl">
          {title || t("common:ComingSoon")}
        </h1>
        {(description || !title) && (
          <p className="mb-6 text-lg font-light text-gray-200">
            {description || t("common:ThisPageIsNotYetAvailable")}
          </p>
        )}
        <Link className={buttonVariants()} to={homeHref}>
          {t("fit:BackToOverview")}
        </Link>
      </div>
    </div>
  );
}
